import { List, Record } from 'immutable';
import uniqueId from '../../../utils/uniqueId';
import { ADD, REMOVE, CLEAR, INFO } from './actions';

export const Notification = new Record({
  id: '',
  text: '',
  type: INFO,
});

export const initialState = new List();

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD: {
      return state
        .filter(n => n.text !== action.text || n.type !== action.notificationType)
        .push(new Notification({
          text: action.text,
          type: action.notificationType,
          id: uniqueId()
        }));
    }
    case REMOVE: {
      return state.filter(n => n.id !== action.notificationId);
    }
    case CLEAR: {
      return new List();
    }
    default: {
      return state;
    }
  }
};
